// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-27f3c58a]{margin-bottom:40px}", "",{"version":3,"sources":["webpack://./resources/js/Jetstream/AuthenticationCardLogo.vue"],"names":[],"mappings":"AAEA,qBACC,kBADD","sourcesContent":["\n\nimg\n\tmargin-bottom: 40px\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
